export type ProofStat = {
  readonly id: string;
  readonly value: number;
  readonly suffix: string;
  readonly label: string;
};

export const PROOF_LABEL = "Reported results";

export const PROOF_ATTRIBUTION = "Reported by teams working with VARIANT3D";

export const PROOF_STATS: readonly ProofStat[] = [
  { id: "development-time", value: 80, suffix: "%", label: "less development time" },
  { id: "sampling-cost", value: 60, suffix: "%", label: "lower sampling cost" },
  { id: "iterations", value: 70, suffix: "%", label: "more iterations" },
  { id: "design-integrity", value: 100, suffix: "%", label: "design integrity" },
];
